export default __webpack_public_path__ + "static/media/loading_pandhora.00007e54.gif";